import React from 'react';

/**
 * Access state for the Props tool, shared with deep components (cards, panels,
 * sheets) without threading booleans through the column factories.
 *
 * `isTeaser` means the viewer has no Props subscription for the current league
 * (anonymous or a DFS-only subscriber): the server has already stripped the
 * board to one free row + locked rows, and the UI shows the upsell instead of
 * the full tool. Enforcement lives in the stokastic-site proxy; this flag only
 * drives presentation.
 */
export interface PropsAccess {
  isTeaser: boolean;
  isAuthenticated: boolean;
  isMobileApp: boolean;
  /** The subscription check itself failed (network / 5xx) — don't sell to a possibly-paying user. */
  checkFailed: boolean;
  recheckSubscription: () => void;
}

export const PropsAccessContext = React.createContext<PropsAccess>({
  isTeaser: false,
  isAuthenticated: true,
  isMobileApp: false,
  checkFailed: false,
  recheckSubscription: () => {},
});

export const usePropsAccess = (): PropsAccess => React.useContext(PropsAccessContext);
